var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pay-status"},[_c('i',{class:`pay-status-icon status-${_vm.status}`}),_vm._v(" "+_vm._s(_vm.statusStr)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }